/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Drop_Out_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Drop out of the tournament?" |
*
* @param {Tournament_Drop_Out_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_drop_out_confirm_title = /** @type {((inputs?: Tournament_Drop_Out_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Drop_Out_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abandonner le tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Retirarse del torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desistir do torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbandonare il torneo?")
	return /** @type {LocalizedString} */ ("Drop out of the tournament?")
});